import { render } from "./ProfileLayout.vue?vue&type=template&id=43640adf"
import script from "./ProfileLayout.vue?vue&type=script&lang=js"
export * from "./ProfileLayout.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "43640adf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43640adf', script)) {
    api.reload('43640adf', script)
  }
  
  module.hot.accept("./ProfileLayout.vue?vue&type=template&id=43640adf", () => {
    api.rerender('43640adf', render)
  })

}

script.__file = "resources/js/Layouts/ProfileLayout.vue"

export default script